/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_AprInputs */

const en_better_studio_month_apr = /** @type {(inputs: Better_Studio_Month_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apr`)
};

/**
* | output |
* | --- |
* | "Apr" |
*
* @param {Better_Studio_Month_AprInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_apr = /** @type {((inputs?: Better_Studio_Month_AprInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_AprInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_apr(inputs)
});